import styled from "styled-components";

export const StatusFeedback = ({
    errorMessage,
    successMessage,
    status
}) => {

    return (
        <>
            {status === "Error" ?
                <StyledMessage error={true}>
                    {errorMessage}
                </StyledMessage> :
                status === "Success" ?
                    <>
                        <StyledMessage error={false}>
                            {successMessage}
                        </StyledMessage>
                    </>
                    : null}
        </>
    );
};

const StyledMessage = styled.p`
    font-weight: 400;
    font-size: 16px;
    color: #218631;
    text-align: center;
    margin-top: 24px;
    ${({ error }) => error && `
    color: #F44336;
  `}
`;